import type { GeometryPadWidgetConfig } from '../geometrypad.model';

/**
 * Classic classroom case: triangle with base on rectangle bottom edge,
 * third vertex inside the rectangle.
 *
 * Uses PointTarget: t1's vertex A is pinned to r1's corner A.
 * The triangle's c param matches r1's width (10) so edge AB aligns with the bottom.
 */
export const TRIANGLE_IN_RECTANGLE_PRESET: GeometryPadWidgetConfig = {
  id: 'triangle-in-rectangle',
  type: 'geometrypad',
  params: {
    elements: {
      r1: {
        type: 'Rectangle',
        params: { w: 10, h: 6 },
      },
      t1: {
        type: 'Triangle',
        params: {
          alpha: 50,
          beta: 60,
          c: 10,
          A: { x: 'r1.point.A.x', y: 'r1.point.A.y' },
        },
      },
    },
  },
  display: {
    geometry: {
      shape: { coloring: true },
      label: { coloring: true },
    },
  },
};
